import { PageController } from '@client/components/_core/layout/PageController';
import { createFileRoute } from '@tanstack/react-router';
import { ClassificationExampleEdit } from '../ClassificationExampleEdit';

export const Route = createFileRoute('/admin-console/platform-content/ai-training/classification-example/view/$id')({
    staticData: {
        breadcrumb: { title: 'View' },
        ui: { title: 'View classification example' },
        presentation: 'overlay',
    },
    component: ViewClassificationExample,
});

function ViewClassificationExample() {
    const { id } = Route.useParams();
    return (
        <PageController route={Route}>
            <ClassificationExampleEdit mode="view" id={id} />
        </PageController>
    );
}
